import React from "react";
import { FiLogOut, FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SwitchRole from "./switchRole";
import { useUserConfig } from "../../Hooks/useUserConfig";
import useUserProfile from "../../Hooks/useUserProfile";
import adminIcon from "./admin.png";
import { Tooltip } from "react-tooltip";
import UpgradeToTeams from "../Intros/UpgradeToTeams";
import { Avatar } from "..";
import { useLoginHook } from "../../Hooks/useLoginHook";
import useMobileCheck from "../../Hooks/useMobileCheck";

function User({ mini = false, onAction = () => {}, compact = false }) {
	const { profile } = useUserProfile();
	const { isMobile } = useMobileCheck();

	const { logout } = useLoginHook();
	const NAVIGATE = useNavigate();
	const { switchRole, role, userConfig } = useUserConfig();
	const [ShowRoles, setShowRoles] = useState(false);
	const [EnableTeams, setEnableTeams] = useState();
	const [logoutLoading, setLogoutLoading] = useState(false);

	const actions = [
		{
			key: "settings",
			label: "Account Settings",
			onClick: () => {
				NAVIGATE("/app/account");
				onAction();
			},
			icon: <FiSettings />,
		},
		{
			key: "logout",
			label: "Sign out",
			onClick: () => {
				setLogoutLoading(true);
				onAction();
				logout();
			},
			icon: <FiLogOut />,
		},
	];

	return (
		<>
			<div className={`user-options ${compact ? "user-options-compact" : ""}`}>
				<div className="profile" role="group" aria-label="User menu">
					<div className="relative">
						<Avatar photo={profile.photo} className="mr-2 avatar" />
						{role === "ADMIN" && (
							<div className="absolute w-4 h-4 -top-3 -left-2">
								<img src={adminIcon} className="w-full" alt="icon" />
							</div>
						)}
					</div>
					{!mini && (
						<>
							<div className="min-w-0 flex-1 overflow-hidden">
								<div className="text-ellipsis whitespace-nowrap overflow-hidden max-w-[10rem]">
									{profile?.fName} {profile?.lName}
								</div>
								<div data-tooltip-id="user-email" data-tooltip-content={profile?.email} className="text-xs text-secondary font-light text-ellipsis whitespace-nowrap overflow-hidden max-w-[10rem]">
									{profile?.email}
								</div>
							</div>
						</>
					)}
				</div>
				<div className={`options ${mini ? "options-compact" : "options-full"}`}>
					{actions.map((a) => (
						<button
							key={a.key}
							type="button"
							onClick={a.onClick}
							data-tooltip-id={mini && !isMobile ? "mini-profile-item" : undefined}
							data-tooltip-content={mini && !isMobile ? a.label : undefined}
							className={mini ? "btn btn-outlined btn-icon" : `btn btn-outlined btn-sm w-full justify-start ${compact ? "!py-1.5 !text-xs" : ""}`}
							disabled={a.key === "logout" ? logoutLoading : false}
						>
							{a.key === "logout" && logoutLoading ? (
								<>
									<svg className="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
										<circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
										<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
									</svg>
									{mini ? null : <span className={compact ? "ml-1.5" : "ml-2"}>Signing out...</span>}
								</>
							) : (
								<>
									{a.icon}
									{mini ? null : <span className={compact ? "ml-1.5" : "ml-2"}>{a.label}</span>}
								</>
							)}
						</button>
					))}
				</div>
			</div>
			<Tooltip id="user-email" className="z-20 !text-xs" />
			{!isMobile && <Tooltip id="mini-profile-item" className="z-20 !text-xs" />}
			<SwitchRole onClose={() => setShowRoles(false)} open={ShowRoles} {...{ switchRole, role, userConfig }} />
			<UpgradeToTeams open={EnableTeams} onClose={() => setEnableTeams(false)} />
		</>
	);
}

export default User;
